var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1467 3C17.1088 3 21 7.04054 21 12.0244C21 17.0082 16.9853 20.9505 12.1944 20.9505C10.494 20.9505 9.67019 20.7102 8.34311 19.7669C8.25172 19.7023 8.12686 19.7191 8.04963 19.8018C7.02889 20.8949 4.41462 21.6625 4.29491 20.17C4.29491 17.5677 3 15.8775 3 11.9753C3 6.85189 7.18464 3 12.1467 3ZM12.2858 7.44111C9.93149 7.31706 8.09339 8.95809 7.68793 11.5243C7.35197 13.6499 7.94665 16.2406 8.45638 16.3711C8.67263 16.4267 9.19136 16.0274 9.56979 15.6695C9.64059 15.6023 9.74871 15.5907 9.83109 15.6424C10.4206 16.0042 11.0874 16.2755 11.8224 16.3143C14.2397 16.4409 16.3816 14.5415 16.509 12.1148C16.6352 9.68815 14.7031 7.56645 12.2858 7.43982V7.44111Z",
    fill: "#6656F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.fd8c0619acae17d8d7f36a50610a9ed2.svg";
export { ForwardRef as ReactComponent };